export const chatDefaultMessage =
  "Esta conversa foi criada automaticamente com paciente após a confirmação do agendamento.";
